import { AnyListenerPredicate } from "@reduxjs/toolkit";
import type { AppState } from "Data/Redux/Reducers";
import { REHYDRATE } from "redux-persist";

export const appRehydratedPredicate: AnyListenerPredicate<AppState> = (action) => {
	return action.type === REHYDRATE;
};
